import styled, { css } from 'styled-components';
import { paddingLeft, paddingTop, marginLeft, marginTop } from '../v2/foundation/spacing/utils.js';

var HorizontalColumnSpacing = css(["", ";"], function (props) {
  return paddingLeft(props.$spacing);
});
var VerticalColumnSpacing = css(["", ";"], function (props) {
  return paddingTop(props.$spacing);
});
var ColumnContainer = styled.div.withConfig({
  displayName: "ColumnContainer",
  componentId: "sc-iq7d35-0"
})(["box-sizing:border-box;", " ", ""], function (props) {
  return props.$horizontal && HorizontalColumnSpacing;
}, function (props) {
  return props.$vertical && VerticalColumnSpacing;
});
var HorizontalGridSpacing = css(["", ";"], function (props) {
  return marginLeft(props.$spacing * -1);
});
var VerticalGridSpacing = css(["", ";"], function (props) {
  return marginTop(props.$spacing * -1);
});
var GridContainer = styled.div.withConfig({
  displayName: "GridContainer",
  componentId: "sc-iq7d35-1"
})(["display:flex;flex-flow:row wrap;", " ", ""], function (props) {
  return props.$horizontal && HorizontalGridSpacing;
}, function (props) {
  return props.$vertical && VerticalGridSpacing;
});

export { ColumnContainer, GridContainer };
